import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/layout/Header.jsx';
import Footer from '../components/layout/Footer.jsx';
import Hero from '../components/landing/Hero.jsx';
import Concepto from '../components/landing/Concepto.jsx';
import Modulos from '../components/landing/Modulos.jsx';
import Plataforma from '../components/landing/Plataforma.jsx';
import ParaQuien from '../components/landing/ParaQuien.jsx';
import Equipo from '../components/landing/Equipo.jsx';
import FAQ from '../components/landing/FAQ.jsx';
import VideoModal from '../components/landing/VideoModal.jsx';
import FloatingCTA from '../components/landing/FloatingCTA.jsx';
import CookieBanner from '../components/shared/CookieBanner.jsx';
import { useScrollReveal } from '../hooks/useScrollReveal.js';

export default function LandingPage() {
  const [videoOpen, setVideoOpen] = useState(false);
  const { hash } = useLocation();
  useScrollReveal();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [hash]);

  return (
    <>
      <Header variant="landing" />
      <Hero onPlay={() => setVideoOpen(true)} />
      <Concepto />
      <div className="section-divider" />
      <Modulos />
      <div className="section-divider" />
      <Plataforma />
      <div className="section-divider" />
      <ParaQuien />
      <div className="section-divider" />
      <Equipo />
      <div className="section-divider" />
      <FAQ />
      <Footer variant="landing" />
      <FloatingCTA />
      {videoOpen && <VideoModal onClose={() => setVideoOpen(false)} />}
      <CookieBanner />
    </>
  );
}
